import '/app/brewery-packages/content/content-editor-plugin-link/src/Link.css-raw';
export default {
  "link": "employees-21b62107-link-d8xOKa"
};